import { useEffect, useState } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { get, post } from "../../utils/apiManager";
import { baseURL } from "../../config/config";
import { toast } from "react-toastify";
import Swal from 'sweetalert2';
import Pagination from 'react-js-pagination';
import { useForm } from "react-hook-form";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import SuccessModal from "../../components/SuccessModal";

const Index = () => {
  const { register, handleSubmit, getValues, setValue } = useForm();
  const { register: registerExcel, handleSubmit: handleSubmitExcel, formState: { errors: ErrorsExcel } } = useForm();

  const [subCategory, setSubCategory] = useState([]);
  const [importModel, setImportModel] = useState(false);
  const Navigate = useNavigate();
  const [count, setCount] = useState(0);
  const [allData, setAllData] = useState([]);
  const [pageData, setPageData] = useState({ page: 1, perPage: 50 });
  const [checkBoxData, setCheckBoxData] = useState([]);
  const location = useLocation();
  const id = location?.search?.split("?")[1];
  const [modalData, setModalData] = useState({ message: "", show: false });

  useEffect(() => { getAllSubCategory(); }, [pageData]);

  const getAllSubCategory = () => {
    get(`/sub-category/${id}?page=${pageData.page}&perPage=${pageData.perPage}&searchItem=${getValues("companyName") || ""}`)
      .then((res) => { setSubCategory(res?.data); setCount(res?.pages); setAllData(res?.allSubCategoryData); })
      .catch((err) => console.log(err));
  };

  const changeStatus = (subId, status) => {
    post(`${baseURL}/sub-category/status`, { id: subId, status: !status })
      .then((res) => { if (res?.status) { setModalData({ message: res.message, show: true }); getAllSubCategory(); } else toast.error(res?.message); })
      .catch((err) => toast.error(err?.response?.data?.error));
  };

  const deleteHandler = (subId) => {
    Swal.fire({ title: 'Are you sure?', text: 'This will delete the subcategory.', icon: 'warning', showCancelButton: true, confirmButtonColor: '#AD2429', cancelButtonColor: '#6b7a99', confirmButtonText: 'Yes, delete it!' })
      .then((result) => {
        if (result.isConfirmed) {
          post(`${baseURL}/sub-category/delete`, { id: subId })
            .then((res) => { if (res?.status) { setModalData({ message: res.message, show: true }); getAllSubCategory(); } else toast.error(res?.message); })
            .catch((err) => toast.error(err?.response?.data?.error));
        }
      });
  };

  const multiStatusHandler = (status) => {
    if (!checkBoxData.length) return;
    Swal.fire({ title: 'Are you sure?', icon: 'warning', showCancelButton: true, confirmButtonColor: '#AD2429', confirmButtonText: 'Yes, change it!' })
      .then((result) => {
        if (result.isConfirmed) {
          post(`${baseURL}/sub-category/multi-status`, { ids: checkBoxData, status })
            .then((res) => { if (res?.status) { setModalData({ message: res.message, show: true }); getAllSubCategory(); setCheckBoxData([]); } else toast.error(res?.message); })
            .catch((err) => toast.error(err?.response?.data?.error));
        }
      });
  };

  const allDeleteHandler = () => {
    if (!checkBoxData.length) return;
    Swal.fire({ title: 'Are you sure?', text: 'This will delete selected subcategories.', icon: 'warning', showCancelButton: true, confirmButtonColor: '#AD2429', confirmButtonText: 'Yes, delete!' })
      .then((result) => {
        if (result.isConfirmed) {
          post(`${baseURL}/sub-category/multi-delete`, { ids: checkBoxData })
            .then((res) => { if (res?.status) { setModalData({ message: res.message, show: true }); getAllSubCategory(); setCheckBoxData([]); } else toast.error(res?.message); })
            .catch((err) => toast.error(err?.response?.data?.error));
        }
      });
  };

  const handleExport = () => {
    const exportsData = allData?.map((item) => ({ categoryName: item?.categoryName, subCategoryName: item?.subCategoryName, description: item.description, status: item?.status ? "Active" : "Inactive" }));
    const ws = XLSX.utils.json_to_sheet(exportsData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    saveAs(new Blob([XLSX.write(wb, { bookType: 'xlsx', type: 'array' })], { type: 'application/octet-stream' }), 'subcategory.xlsx');
  };

  const onSubmitExcelFile = (data) => {
    const formData = new FormData();
    formData.append("excel", data?.excelFile?.[0]);
    formData.append("categoryId", id);
    post(`${baseURL}/sub-category/excel/add`, formData, 1)
      .then((res) => { if (res?.status) { setModalData({ message: res.message, show: true }); setImportModel(false); getAllSubCategory(); } else toast.error(res?.message); })
      .catch((err) => toast.error(err?.response?.data?.error));
  };

  const checkBoxHandler = (subId) => {
    setCheckBoxData(prev => prev.includes(subId) ? prev.filter(i => i !== subId) : [...prev, subId]);
  };

  const categoryName = allData?.[0]?.categoryName;

  const pill = (active) => (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '3px 9px', borderRadius: 100, fontSize: 11, fontWeight: 700, background: active ? '#dcfce7' : '#fee2e2', color: active ? '#15803d' : '#b91c1c' }}>
      <span style={{ fontSize: 7 }}>●</span>{active ? 'Active' : 'Inactive'}
    </span>
  );

  const thS = { padding: '12px 16px', fontSize: 11, fontWeight: 700, letterSpacing: '0.07em', textTransform: 'uppercase', color: '#9aa5c0', textAlign: 'left', borderBottom: '1px solid #edf0f7', background: '#f8f9fc', whiteSpace: 'nowrap' };
  const tdS = { padding: '12px 16px', fontSize: 14, color: '#3a4a6a', borderBottom: '1px solid #f0f2f8', verticalAlign: 'middle', textAlign: 'left' };

  return (
    <div style={{ fontFamily: "'Segoe UI', system-ui, sans-serif" }}>
      <div style={{ background: '#fff', borderRadius: 14, border: '1px solid #edf0f7', boxShadow: '0 1px 4px rgba(26,39,68,.05)', overflow: 'hidden' }}>

        {/* Header */}
        <div style={{ padding: '18px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #edf0f7', flexWrap: 'wrap', gap: 10 }}>
          <div>
            <h3 style={{ fontSize: 16, fontWeight: 700, color: '#0a1628', margin: 0 }}>
              {categoryName ? `${categoryName} — Sub Categories` : 'Sub Categories'}
            </h3>
            <p style={{ fontSize: 13, color: '#9aa5c0', margin: '3px 0 0' }}>Manage subcategories for this category</p>
          </div>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <button onClick={() => setImportModel(true)} style={{ background: '#eff6ff', color: '#1d4ed8', border: 'none', borderRadius: 8, padding: '8px 14px', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>↑ Import</button>
            <button onClick={handleExport} style={{ background: '#f0fdf4', color: '#15803d', border: 'none', borderRadius: 8, padding: '8px 14px', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>↓ Export</button>
            <button onClick={() => Navigate('/admin/category')} style={{ background: '#f0f2f8', color: '#5a6a8a', border: 'none', borderRadius: 8, padding: '8px 14px', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>← Back to Categories</button>
            <button onClick={() => Navigate(`/admin/sub-category/add?${id}&${categoryName}`)} style={{ background: '#AD2429', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 14px', fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>+ Add Sub Category</button>
          </div>
        </div>

        {/* Bulk actions + Search */}
        <div style={{ padding: '12px 24px', borderBottom: '1px solid #edf0f7', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10 }}>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            {checkBoxData.length > 0 && (
              <>
                <span style={{ fontSize: 13, color: '#6b7a99' }}>{checkBoxData.length} selected</span>
                <button onClick={() => multiStatusHandler(true)} style={{ background: '#dcfce7', color: '#15803d', border: 'none', borderRadius: 7, padding: '6px 12px', fontSize: 12, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>Activate All</button>
                <button onClick={() => multiStatusHandler(false)} style={{ background: '#fee2e2', color: '#b91c1c', border: 'none', borderRadius: 7, padding: '6px 12px', fontSize: 12, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>Deactivate All</button>
                <button onClick={allDeleteHandler} style={{ background: '#fee2e2', color: '#b91c1c', border: 'none', borderRadius: 7, padding: '6px 12px', fontSize: 12, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>Delete All</button>
              </>
            )}
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <input placeholder="Search subcategories..." {...register("companyName")}
              style={{ padding: '8px 14px', borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 14, color: '#0a1628', outline: 'none', width: 220, fontFamily: 'inherit' }} />
            <button onClick={() => getAllSubCategory()} style={{ background: '#1a2744', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 16px', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>Search</button>
            <button onClick={() => { setValue("companyName", ""); getAllSubCategory(); }} style={{ background: '#f0f2f8', color: '#5a6a8a', border: 'none', borderRadius: 8, padding: '8px 16px', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>Clear</button>
          </div>
        </div>

        {/* Table */}
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={{ ...thS, width: 40 }}>
                  <input type="checkbox"
                    onChange={(e) => setCheckBoxData(e.target.checked ? subCategory.map(s => s._id) : [])}
                    checked={checkBoxData.length === subCategory?.length && subCategory?.length > 0}
                    style={{ cursor: 'pointer' }} />
                </th>
                {['Name', 'Description', 'Status', 'Actions'].map(h => <th key={h} style={thS}>{h}</th>)}
              </tr>
            </thead>
            <tbody>
              {subCategory?.length > 0 ? subCategory.map((item) => (
                <tr key={item._id} onMouseEnter={e => e.currentTarget.style.background = '#fafbfd'} onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                  <td style={tdS}>
                    <input type="checkbox" checked={checkBoxData.includes(item._id)} onChange={() => checkBoxHandler(item._id)} style={{ cursor: 'pointer' }} />
                  </td>
                  <td style={{ ...tdS, fontWeight: 600, color: '#0a1628' }}>{item?.name}</td>
                  <td style={{ ...tdS, color: '#6b7a99' }}>{item?.description || <span style={{ color: '#c0c8d8' }}>—</span>}</td>
                  <td style={tdS}>{pill(item?.isActive)}</td>
                  <td style={tdS}>
                    <div style={{ display: 'flex', gap: 5 }}>
                      <button onClick={() => changeStatus(item._id, item?.isActive)} title={item?.isActive ? 'Deactivate' : 'Activate'}
                        style={{ width: 28, height: 28, borderRadius: 6, border: 'none', background: item?.isActive ? '#fee2e2' : '#dcfce7', color: item?.isActive ? '#b91c1c' : '#15803d', cursor: 'pointer', fontSize: 12 }}>
                        {item?.isActive ? '✕' : '✓'}
                      </button>
                      <button onClick={() => Navigate(`/admin/category/sub-category/edit?${id}&${item._id}&${categoryName}`)} title="Edit"
                        style={{ width: 28, height: 28, borderRadius: 6, border: 'none', background: '#eff6ff', color: '#1d4ed8', cursor: 'pointer', fontSize: 12 }}>✎</button>
                      <button onClick={() => deleteHandler(item._id)} title="Delete"
                        style={{ width: 28, height: 28, borderRadius: 6, border: 'none', background: '#fee2e2', color: '#b91c1c', cursor: 'pointer', fontSize: 12 }}>🗑</button>
                    </div>
                  </td>
                </tr>
              )) : (
                <tr><td colSpan={5} style={{ ...tdS, textAlign: 'center', padding: '48px', color: '#9aa5c0' }}>No subcategories found</td></tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {subCategory?.length > 0 && (
          <div style={{ padding: '14px 24px', borderTop: '1px solid #edf0f7', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ fontSize: 13, color: '#9aa5c0' }}>Page {pageData.page} · {pageData.perPage} per page</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <Pagination itemClass="page-item" linkClass="page-link" activePage={pageData.page} itemsCountPerPage={pageData.perPage} totalItemsCount={count} pageRangeDisplayed={5} onChange={(page) => setPageData(prev => ({ ...prev, page }))} />
              <select onChange={(e) => setPageData(prev => ({ ...prev, perPage: parseInt(e.target.value), page: 1 }))}
                style={{ padding: '6px 10px', borderRadius: 7, border: '1px solid #e2e8f0', fontSize: 13, color: '#3a4a6a', background: '#fff', fontFamily: 'inherit' }}>
                <option value="25">25</option><option value="50">50</option><option value="75">75</option><option value="100">100</option>
              </select>
            </div>
          </div>
        )}
      </div>

      {/* Import Modal */}
      {importModel && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(10,22,40,.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: '#fff', borderRadius: 14, width: 480, boxShadow: '0 20px 60px rgba(0,0,0,.2)', overflow: 'hidden' }}>
            <div style={{ padding: '18px 24px', borderBottom: '1px solid #edf0f7', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: '#0a1628' }}>Upload Sub Categories</h3>
              <button onClick={() => setImportModel(false)} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#9aa5c0' }}>×</button>
            </div>
            <form onSubmit={handleSubmitExcel(onSubmitExcelFile)} style={{ padding: '24px' }}>
              <div style={{ marginBottom: 20 }}>
                <label style={{ fontSize: 13, fontWeight: 600, color: '#3a4a6a', marginBottom: 6, display: 'block' }}>Upload File</label>
                <input type="file" accept=".xlsx,.xls" {...registerExcel("excelFile", { required: true })}
                  style={{ width: '100%', padding: '10px 14px', borderRadius: 8, border: '1.5px solid #e2e8f0', fontSize: 14, fontFamily: 'inherit', boxSizing: 'border-box' }} />
                {ErrorsExcel.excelFile && <span style={{ fontSize: 12, color: '#AD2429', marginTop: 4, display: 'block' }}>File is required</span>}
              </div>
              <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
                <button type="button" onClick={() => setImportModel(false)} style={{ background: '#f0f2f8', color: '#5a6a8a', border: 'none', borderRadius: 8, padding: '10px 20px', fontSize: 14, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>Cancel</button>
                <button type="submit" style={{ background: '#AD2429', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 20px', fontSize: 14, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>Upload</button>
              </div>
            </form>
          </div>
        </div>
      )}

      <SuccessModal message={modalData?.message} showModal={modalData?.show} setShowModal={setModalData} />
    </div>
  );
};

export default Index;
